"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ResellerSalesFooter = void 0;
exports.default = ResellerSalesFooterWrap;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _reactMintl = require("@godaddy/react-mintl");
var _linkedin = _interopRequireDefault(require("@ux/icon/linkedin"));
var _facebook = _interopRequireDefault(require("@ux/icon/facebook"));
var _twitter = _interopRequireDefault(require("@ux/icon/twitter"));
var _social = _interopRequireDefault(require("@ux/icon/social"));
var _link = _interopRequireDefault(require("@ux/link"));
var _currencySelector = _interopRequireDefault(require("@ux/currency-selector"));
var _golfToEid = _interopRequireDefault(require("golf-to-eid"));
var _componentUtilities = require("@ux/component-utilities");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
const eidPrefix = 'uxp.hyd.reseller_sales_footer';
const footerLinkEid = {
  prefix: eidPrefix,
  postfix: 'link.click'
};
const utosLinkId = 'utos';

/**
 * Mapping of icon names to their Icon components.
 *
 * @type {Object}
 * @private
 */
const Icons = {
  linkedin: _linkedin.default,
  facebook: _facebook.default,
  twitter: _twitter.default
};

/**
 * Helper component for social media links
 *
 * @returns {ReactElement} The social media link
 */
class SocialMediaLinkItem extends _react.Component {
  render() {
    const {
      link
    } = this.props;
    const Icon = link && Icons[link.icon] || _social.default;
    return /*#__PURE__*/_react.default.createElement("li", null, link && link.href && link.id && link.title && /*#__PURE__*/_react.default.createElement(_link.default, {
      href: link === null || link === void 0 ? void 0 : link.href,
      "data-eid": (0, _golfToEid.default)(link === null || link === void 0 ? void 0 : link.id, footerLinkEid),
      target: "_blank",
      "aria-label": link === null || link === void 0 ? void 0 : link.title
    }, /*#__PURE__*/_react.default.createElement(Icon, null)));
  }
}
SocialMediaLinkItem.propTypes = {
  link: _propTypes.object.isRequired
};

/**
 * Render and expose the Product navigation as a Component.
 *
 * @param {Object} props Properties
 * @returns {ReactElement} Namespaced Product Nav.
 * @api public
 */
class ResellerSalesFooter extends _react.Component {
  constructor(props) {
    super(props);
    this.links = props.footer;
    this.utosLink = props.legal.filter(link => link.id === utosLinkId)[0];
    this.legalLinks = props.legal.filter(link => link.id !== utosLinkId);
    this.hasSocialMediaLinks = props.socialMedia && props.socialMedia.length > 0;
    this.socialMediaLinks = props.socialMedia;
    this.utosLinkValues = this.utosLink && _objectSpread(_objectSpread({}, this.utosLink), {}, {
      eid: (0, _golfToEid.default)(this.utosLink.id, footerLinkEid)
    });
  }
  buildLink(link) {
    const linkProps = _objectSpread(_objectSpread({}, link), {}, {
      'data-eid': (0, _golfToEid.default)(link.id, footerLinkEid)
    });
    return /*#__PURE__*/_react.default.createElement(_link.default, linkProps, link === null || link === void 0 ? void 0 : link.title);
  }

  /**
   * Renders each given social media link as a SocialMediaLinkItem
   *
   * @param {Object[]} socialMediaLinks The links to render
   * @returns {SocialMediaLinkItem[]} The rendered links
   */
  renderSocialMediaLinks(socialMediaLinks) {
    return socialMediaLinks.map(socialMediaLink => /*#__PURE__*/_react.default.createElement(SocialMediaLinkItem, {
      key: socialMediaLink.id,
      link: socialMediaLink
    }));
  }

  /**
   * Renders footer
   *
   * @returns {ReactElement} footer
   */
  render() {
    var _this$utosLinkValues, _this$utosLinkValues2, _this$utosLinkValues3;
    const {
      props,
      links,
      legalLinks,
      utosLink
    } = this;
    const {
      resellerTypeId,
      multiCurrencyPricingEnabled,
      features
    } = props;
    const hasLinks = !!(links && links.length);
    const hasUtos = !!utosLink;
    const hasLegalLinks = !!(legalLinks && legalLinks.length);
    const isApiReseller = resellerTypeId === 3;
    const is123Reg = props.privateLabelId === 587240;
    const doNotSellId = 'Sales:Footer:Privacy:DoNotSell';
    const doNotSellMessage = /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: doNotSellId
    });
    const termsOfService = /*#__PURE__*/_react.default.createElement("a", {
      href: (_this$utosLinkValues = this.utosLinkValues) === null || _this$utosLinkValues === void 0 ? void 0 : _this$utosLinkValues.href,
      "data-eid": (_this$utosLinkValues2 = this.utosLinkValues) === null || _this$utosLinkValues2 === void 0 ? void 0 : _this$utosLinkValues2.eid
    }, (_this$utosLinkValues3 = this.utosLinkValues) === null || _this$utosLinkValues3 === void 0 ? void 0 : _this$utosLinkValues3.title);
    const currencySelectorProps = {
      eidPrefix: footerLinkEid.prefix,
      market: props.market,
      currency: props.currency,
      urls: props.urls,
      privateLabelId: props.privateLabelId,
      isReseller: true,
      messages: props.messages
    };
    return /*#__PURE__*/_react.default.createElement(_reactMintl.IntlProvider, {
      locale: props.market,
      messages: props.messages
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "reseller-footer",
      role: "contentinfo"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "reseller-container"
    }, hasLinks && /*#__PURE__*/_react.default.createElement("ul", {
      className: "reseller-footer-links"
    }, links.map((link, index) => /*#__PURE__*/_react.default.createElement("li", {
      key: index
    }, this.buildLink(link)))), !isApiReseller && multiCurrencyPricingEnabled && !is123Reg && /*#__PURE__*/_react.default.createElement("div", {
      className: "currency-selector-wrapper"
    }, /*#__PURE__*/_react.default.createElement(_currencySelector.default, currencySelectorProps)), this.hasSocialMediaLinks && /*#__PURE__*/_react.default.createElement("ul", {
      className: "reseller-footer-social-media-links"
    }, this.renderSocialMediaLinks(this.socialMediaLinks)), hasUtos && /*#__PURE__*/_react.default.createElement("p", {
      className: "reseller-footer-utos"
    }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: "SalesReseller:Footer:UToS:Simple",
      values: {
        termsOfService
      }
    })), hasLegalLinks && /*#__PURE__*/_react.default.createElement("ul", {
      className: "reseller-footer-legal"
    }, legalLinks.map((link, index) => /*#__PURE__*/_react.default.createElement("li", {
      key: index
    }, this.buildLink(link))), features.doNotSellLink && props.urls.cookies.href && /*#__PURE__*/_react.default.createElement("li", {
      className: "reseller-footer-legal"
    }, /*#__PURE__*/_react.default.createElement(_link.default, {
      className: "reseller-footer-do-not-sell",
      urlArgs: props.urlArgs,
      href: props.urls.cookies.href,
      "data-eid": (0, _golfToEid.default)(doNotSellId, footerLinkEid)
    }, doNotSellMessage))))));
  }
}
exports.ResellerSalesFooter = ResellerSalesFooter;
const linksPropType = (0, _propTypes.arrayOf)((0, _propTypes.shape)({
  href: _propTypes.string.isRequired,
  title: _propTypes.string.isRequired,
  id: _propTypes.string.isRequired
})).isRequired;
ResellerSalesFooter.propTypes = {
  breakpoint: _propTypes.string,
  messages: _propTypes.object.isRequired,
  market: _propTypes.string.isRequired,
  resellerTypeId: _propTypes.number.isRequired,
  features: _propTypes.object,
  footer: linksPropType,
  legal: linksPropType,
  socialMedia: linksPropType,
  multiCurrencyPricingEnabled: _propTypes.bool,
  currency: _propTypes.string,
  urls: _propTypes.object,
  urlArgs: _propTypes.object,
  privateLabelId: _propTypes.number
};
function ResellerSalesFooterWrap(props) {
  const {
    breakpoint
  } = (0, _componentUtilities.useBreakpoints)('mobile', 'phablet', 'tablet', 'desktop', 'large');
  return /*#__PURE__*/_react.default.createElement(ResellerSalesFooter, (0, _extends2.default)({}, props, {
    breakpoint: breakpoint
  }));
}
ResellerSalesFooterWrap.propTypes = {};